export enum TableTabs {
  All = 'all',
  Selected = 'selected',
}

export enum ModalTableMultiselectMode {
  WithTabs = 'with-tabs',
  SelectedOnly = 'selected-only',
}
